module.exports = __webpack_public_path__ + "lock.svg?1793698113381";